import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  // {
  //   path: "",
  //   loadChildren: () => import("./tabs/tabs.module").then(m => m.TabsPageModule)
  // },
  { path: "", redirectTo: "/", pathMatch: "full" },
  {
    path: "walkthrough",
    loadChildren: () =>
      import("./walkthrough/walkthrough.module").then(
        (m) => m.WalkthroughPageModule
      ),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "tabs",
    loadChildren: () =>
      import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "friends",
    loadChildren: "./friends/friends.module#FriendsPageModule",
  },
  // GROUPS
  {
    path: "group/:id",
    loadChildren: "./group-collection/group/group.module#GroupPageModule",
  },
    {
      path: "grouptab/:id",
      loadChildren: "./group-collection/grouptab/grouptab.module#GroupPageModule",
    },
  {
    path: "addgroupmembers/:id",
    loadChildren:
      "./group-collection/addmembers/addmembers.module#AddmembersPageModule",
  },
  {
    path: "groupinfo/:id",
    loadChildren:
      "./group-collection/groupinfo/groupinfo.module#GroupinfoPageModule",
  },
  {
    path: "groups",
    loadChildren: "./group-collection/groups/groups.module#GroupsPageModule",
  },
  {
    path: "newgroup",
    loadChildren:
      "./group-collection/newgroup/newgroup.module#NewgroupPageModule",
  },

  // MISSIONS
  {
    path: "mission/:id",
    loadChildren:
      "./mission-collection/mission/mission.module#MissionPageModule",
  },
  {
    path: "addmissionmembers/:id",
    loadChildren:
      "./mission-collection/addmembers/addmembers.module#AddmembersPageModule",
  },
  {
    path: "missioninfo/:id",
    loadChildren:
      "./mission-collection/missioninfo/missioninfo.module#MissioninfoPageModule",
  },
  {
    path: "missions",
    loadChildren:
      "./mission-collection/missions/missions.module#MissionsPageModule",
  },
  {
    path: "newmission",
    loadChildren:
      "./mission-collection/newmission/newmission.module#NewmissionPageModule",
  },

  // {
  //   path: "missions",
  //   loadChildren: "./missions/missions.module#MissionsPageModule"
  // },
  // {
  //   path: "mission/:id",
  //   loadChildren: "./mission/mission.module#MissionPageModule"
  // },
  {
    path: "workouts",
    loadChildren: "./workouts/workouts.module#WorkoutsPageModule",
  },
  {
    path: "workout/:id",
    loadChildren: "./workout/workout.module#WorkoutPageModule",
  },
  {
    path: "essentials",
    loadChildren: "./essentials/essentials.module#EssentialsPageModule",
  },
  {
    path: "essential/:id",
    loadChildren: "./essential/essential.module#EssentialPageModule",
  },
  { path: "login", loadChildren: "./login/login.module#LoginPageModule" },
  {
    path: "imagemodal",
    loadChildren: "./imagemodal/imagemodal.module#ImagemodalPageModule",
  },
  {
    path: "message/:id",
    loadChildren: "./message/message.module#MessagePageModule",
  },
  {
    path: "messages",
    loadChildren: "./messages/messages.module#MessagesPageModule",
  },
  {
    path: "blockedlist",
    loadChildren: "./blockedlist/blockedlist.module#BlockedlistPageModule",
  },
  {
    path: "register",
    loadChildren: "./register/register.module#RegisterPageModule",
  },
  {
    path: "userinfo/:id",
    loadChildren: "./userinfo/userinfo.module#UserinfoPageModule",
  },
  {
    path: "profile",
    loadChildren: "./profile/profile.module#ProfilePageModule",
  },
  {
    path: "schedule",
    loadChildren: "./schedule/schedule.module#SchedulePageModule",
  },
  {
    path: "mission-approvals",
    loadChildren:
      "./mission-collection/mission-approvals/mission-approvals.module#MissionApprovalsPageModule",
  },
  {
    path: "create-user",
    loadChildren: "./create-user/create-user.module#CreateUserPageModule",
  },
  { path: "users", loadChildren: "./users/users.module#UsersPageModule" },
  {
    path: "articles",
    loadChildren: "./articles/articles.module#ArticlesPageModule",
  },
  {
    path: "performance-group",
    loadChildren:
      "./performance-group/performance-group.module#PerformanceGroupPageModule",
  },
  {
    path: "edit-workout/:id",
    loadChildren:
      "./workouts/edit-workout/edit-workout.module#EditWorkoutPageModule",
  },
  {
    path: "edit-workout/:workoutId/edit-workout-action/:id",
    loadChildren:
      "./workouts/edit-workout-action/edit-workout-action.module#EditWorkoutActionPageModule",
  },
  {
    path: "quickread",
    loadChildren: () =>
      import("./quickreads/quickread.module").then((m) => m.QuickreadModule),
  },
  { path: 'videovault', loadChildren: './video-vault/video-vault.module#VideoVaultPageModule' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
